// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/demo.css
// module id = 947H
// module chunks = 4